export default function Textarea({...props}) {
  return (
    <textarea className="w-full" {...props}/>
  )
}
